import { useEffect, useState } from 'react'
import { Input, Label, Select } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'
import { fetchZoneQuotazioni } from '@/services/zone-quotazioni.service'
import { ZONE_QUOTAZIONI } from '@/data/zone-quotazioni'

// Zone marcate attiva:false nel file hardcoded vengono nascoste dal selettore
// (attivabili in futuro togliendo il flag). Vedi src/data/zone-quotazioni.ts.
const INACTIVE_ZONE_NAMES = new Set(
  ZONE_QUOTAZIONI.filter((z) => z.attiva === false).map((z) => z.nome)
)

export function AddressStep() {
  const { formData, updateFormData } = useValuationStore()
  const [zoneOptions, setZoneOptions] = useState<{ value: string; label: string }[]>([])
  const [isLoadingZones, setIsLoadingZones] = useState(true)

  useEffect(() => {
    setIsLoadingZones(true)
    fetchZoneQuotazioni()
      .then((zones) => {
        const names = zones
          .filter((z) => !INACTIVE_ZONE_NAMES.has(z.nome))
          .map((z) => z.nome)
          .sort((a, b) => a.localeCompare(b, 'it'))
        setZoneOptions(names.map((name) => ({ value: name, label: name })))
      })
      .finally(() => setIsLoadingZones(false))
  }, [])

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Dove si trova l'immobile?</h2>
        <p className="mt-1 text-gray-600">
          Seleziona la zona in cui si trova l'immobile
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="zoneName" required>
            Zona di riferimento
          </Label>
          <Select
            id="zoneName"
            value={formData.zoneName || ''}
            onChange={(e) => updateFormData({ zoneName: e.target.value || undefined })}
            options={zoneOptions}
            placeholder={isLoadingZones ? 'Caricamento zone...' : 'Seleziona la zona'}
            disabled={isLoadingZones}
          />
          <p className="mt-1 text-sm text-gray-500">
            Seleziona la zona in cui si trova l'immobile per ottenere una valutazione accurata
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-[1fr_140px] gap-4">
          <div>
            <Label htmlFor="address" required>
              Via
            </Label>
            <Input
              id="address"
              value={formData.address || ''}
              onChange={(e) => updateFormData({ address: e.target.value })}
              placeholder="Es. Via Roma"
              autoComplete="address-line1"
            />
          </div>

          <div>
            <Label htmlFor="streetNumber" required>
              N. civico
            </Label>
            <Input
              id="streetNumber"
              value={formData.streetNumber || ''}
              onChange={(e) => updateFormData({ streetNumber: e.target.value })}
              placeholder="Es. 12"
              inputMode="text"
              autoComplete="address-line2"
            />
          </div>
        </div>
        <p className="-mt-2 text-sm text-gray-500">
          L'indirizzo esatto ci serve per verificare la valutazione e contattarti come proprietario dell'immobile. I dati sono trattati in modo riservato.
        </p>
      </div>
    </div>
  )
}
